module.exports = __webpack_public_path__ + "static/media/lyc_logo.f33a81c5.svg";